import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput } from '../components';
import DatePicker from 'react-datepicker';
import { userActions, generalActions } from '../actions';
import { generalService } from '../services';


class HomePage extends React.Component {
  constructor(props) {
      super(props);

      this.pid = 402; //home page
      this.props.dispatch(generalActions.getContent(0,this.pid));  

      this.state = {
        id: null,
        payload:{
          slider1: '',
          slider2: '',
          slider3: '',
          description1: '',
          description2: '',
          description3: ''
        },
        isLoaded :false,
        isEdit :false,
        lastEvent: null
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

  }

  componentWillReceiveProps(props){

      const { content, upload } = props;
      const { data, id } = content;
      const { payload } = this.state;

      if(data && !this.state.isEdit){
        let dataPayload = {
          slider1: data[0].slider1,
          slider2: data[0].slider2,
          slider3: data[0].slider3,
          description1: data[0].description1,
          description2: data[0].description2,
          description3: data[0].description3
        }

        this.setState({ payload:dataPayload, id:data[0].id, isLoaded:true, isEdit:true });

      }else{

        if(!upload.uploaded){
          setTimeout(()=>this.setState({ isLoaded: true}),1000);  
        }

      }

      if(upload.uploaded){
        this.setState({payload:{...payload, [this.state.lastEvent]:upload.data}});
      }
  }

  handleChange(e) { 
    const { name, value } = e.target;
    const { payload } = this.state;

    if(name === 'title'){
      this.setState({payload:{...payload, [name]:value, slug:value.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-')}});
    }else{
      this.setState({payload:{...payload, [name]:value}});  
    }
  }

  handleFileChange(e) {
      const { name, value } = e.target;

      const file = e.target.files[0];
      const formData = new FormData();

      if(file){
        formData.set('file', file, file.name);
        
        if (formData) {
          this.props.dispatch(generalActions.postUpload(formData));
        }

        this.setState({lastEvent: name});
      }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;
    const payload = this.state.payload;

    this.setState({ submitted: true });

    if(id){
      dispatch(generalActions.postContent(payload, id, this.pid));  
    }else{
      dispatch(generalActions.putContent(payload, this.pid));  
    }
  }

  handleDelete(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;

    if(id){
      dispatch(generalActions.deleteContent(id));  
    }
  }

  render() {
    const {payload} = this.state;
    return (
      <div className={this.state.isLoaded ? "content-wrapper" : "content-wrapper loader-light"}>
      {
        this.state.isLoaded ?
        <form role="form" name="contact" className="needs-validation" noValidate="true">
          <section className="content-header clearfix">
            <h1 className="content-header-title">
              Home
            </h1>
            <div className="btn-placeholder">
              <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>
                <span className="visible-xs"><i className="fa fa-check"></i>&nbsp;</span>
                <span className="hidden-xs">Save</span>
              </button>
            </div>
          </section>
            <section className="content">
              <Section section_title="Home Banner" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Banner 1"
                    input_name="slider1"
                    input_helper="Recommended dimensions of 545 × 344 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.slider1}
                  />
                  <TextArea
                    input_label="Banner 1 Title"
                    input_placeholder="Enter Banner Title"
                    input_name="description1"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.description1}
                  />
                  <ImageInput
                    input_label="Banner 2"
                    input_name="slider2"
                    input_helper="Recommended dimensions of 545 × 344 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.slider2}
                  />
                  <TextArea
                    input_label="Banner 2 Title"
                    input_placeholder="Enter Banner Title"
                    input_name="description2"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.description2}
                  />
                  <ImageInput
                    input_label="Banner 3"
                    input_name="slider3"
                    input_helper="Recommended dimensions of 545 × 344 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.slider3}
                  />
                  <TextArea
                    input_label="Banner 3 Title"
                    input_placeholder="Enter Banner Title"
                    input_name="description3"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.description3}
                  />
                </div>
              </Section>
            </section>
          </form>
          :
        <div className="loader"></div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { content, upload } = general;
    return {
        content,
        upload
    };
}

const connectedHomePage = connect(mapStateToProps)(HomePage);
export { connectedHomePage as HomePage };


// WEBPACK FOOTER //
// ./src/pages/HomePage.js